FollowService = function (container) {
    this._callbacks = {};
    this._container = container;
    this._fileExchangeId = container.getAttribute('data-fileexchange-id');
};

// Partial implementation of the standard EventTarget method
FollowService.prototype.addEventListener = function (type, listener) {
    this._callbacks[type] = listener;
};

// Set the initial follow/unfollow button
FollowService.prototype.load = function () {
    const onSuccess = (responseData) => {
        this.updateFormHtml(responseData.form);

        if (this._callbacks.load) {
            this._callbacks.load({ data: { isFollowing: responseData.following } });
        }
    };

    fetch(window.location.origin + '/matlabcentral/fileexchange/' + this._fileExchangeId + '/follow', {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
    })
        .then(response => response.json())
        .then(onSuccess)
        .catch(() => {});
};

FollowService.prototype.update = function () {
    const onSuccess = (responseData) => {
        this.updateFormHtml(responseData.form);

        if (responseData.following === true) {
            document.getElementById('followSuccess').classList.remove('d-none');
        } else {
            document.getElementById('followSuccess').classList.add('d-none');
        }
    };

    const form = this._container.querySelector('form');
    const url = form.getAttribute('action');
    const method = form.querySelector('input[name=_method]');
    const csrfToken = document.querySelector('meta[name="csrf-token"]');

    const requestData = { file_exchange_id: this._fileExchangeId };

    if (method) {
        requestData._method = method.value;
    }

    // Convert to form-encoded data (Rails default)
    const formData = new URLSearchParams();
    for (const key in requestData) {
        formData.append(key, requestData[key]);
    }

    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
            'X-CSRF-Token': csrfToken.getAttribute('content')
        },
        credentials: 'same-origin',
        body: formData
    })
        .then(response => response.json())
        .then(onSuccess)
        .catch(() => {});
};

FollowService.prototype.updateFormHtml = function (html) {
    this._container.innerHTML = html;

    const followButton = document.getElementById('followActionButton');

    const onSubmit = (event) => {
        event.preventDefault();
        this.update();
    };

    followButton.addEventListener('click', onSubmit);
};
